export function slugifyCity(value) {
  return (value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "");
}

export function koopHref(listing) {
  return `/koopwoning/${slugifyCity(listing.city)}/${listing.slug}`;
}

export const SALE_STATUS_LABEL = {
  concept: "Concept",
  actief: "Actief",
  onder_bod: "Onder bod",
  verkocht_ov: "Verkocht o.v.",
  verkocht: "Verkocht",
  ingetrokken: "Ingetrokken",
};

export const SALE_STATUS_COLOR = {
  concept: "bg-slate-100 text-slate-600",
  actief: "bg-success/15 text-success",
  onder_bod: "bg-warning/15 text-amber-700",
  verkocht_ov: "bg-brandblue-light text-brandblue",
  verkocht: "bg-slate-800 text-white",
  ingetrokken: "bg-slate-100 text-slate-400",
};

export const LEAD_STATUS_LABEL = {
  NEW: "Nieuw",
  CONTACTED: "Contact opgenomen",
  APPOINTMENT: "Afspraak",
  QUALIFIED: "Gekwalificeerd",
  WON: "Gewonnen",
  LOST: "Verloren",
};
